module.exports = {
        srcSet: __webpack_public_path__ + "assets/images/round-button/round-button-bg-pressed-36.png"+" 36w",
        images: [{path: __webpack_public_path__ + "assets/images/round-button/round-button-bg-pressed-36.png",width: 36,height: 37}],
        src: __webpack_public_path__ + "assets/images/round-button/round-button-bg-pressed-36.png",
        toString: function(){return __webpack_public_path__ + "assets/images/round-button/round-button-bg-pressed-36.png"},
        
        width: 36,
        height: 37
      }